import { KypayInstrumentIcon } from "@/atoms-react/crypto-icon/KypayInstrumentIcon.react";
import { Base } from "@/atoms-react/text/Text.react";
import { FromURL } from "@/features/flow/types";
import type { identityPartners } from "@/features/user/types";
import { usei18n } from "@/features/utils/hooks/use-i18n";
import { isSystemThemeDark } from "@/features/utils/theme";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type propsHeader = {
  origin: FromURL;
  identityPartner: identityPartners;
};
export const TransfertCardHeader = (props: propsHeader) => {
  const { t } = useTranslation(["pass"]);
  const [isDark, setIsDark] = useState<boolean>(false);
  const { getLanguage } = usei18n();
  useEffect(() => {
    const prefersDark = isSystemThemeDark();

    if (prefersDark) {
      setIsDark(true);
    }
  }, []);
  return (
    <div className="mb-2 hidden justify-between lg:flex lg:flex-row">
      <div className="flex w-4/5 flex-col justify-start lg:w-1/4">
        <div className="flex">
          <Base className="font-semibold text-2xl">
            {props.origin === FromURL.None ? "KYPAY" : ""}
          </Base>
        </div>
      </div>

      {getLanguage() === "en" ? (
        <div className="flex w-full flex-row lg:w-1/2">
          <KypayInstrumentIcon isDark={isDark} className="flex w-14 flex-col justify-center" />
          <Base className="ml-2 font-semibold text-lg">
            {" "}
            {props.origin === FromURL.None
              ? t("olkypass.mainPage.olkypass.dashbord.title")
              : t("olkypass.mainPage.olkypass.dashbord.title_sub_account")}
          </Base>
        </div>
      ) : (
        <div className="flex w-full flex-row lg:w-1/2">
          <Base className="font-semibold text-lg">
            {props.origin === FromURL.None
              ? t("olkypass.mainPage.olkypass.dashbord.title")
              : t("olkypass.mainPage.olkypass.dashbord.title_sub_account")}
          </Base>
          <KypayInstrumentIcon isDark={isDark} className="ml-2 flex w-14 flex-col justify-center" />
        </div>
      )}
      {props.origin !== FromURL.None ? (
        props.identityPartner?.mode !== "TOKEN" ? (
          <Base className="w-1/2 w-full font-semibold text-md lg:w-1/3 lg:text-lg"></Base>
        ) : (
          <Base className="w-1/2 w-full font-semibold text-md lg:w-1/3 lg:text-lg">Token</Base>
        )
      ) : (
        <div className="flex w-1/2 flex-row lg:w-1/4">
          <div className="flex w-full flex-row">
            <KypayInstrumentIcon isDark={isDark} className="flex w-14 flex-col justify-center" />
            <Base className="ml-2 font-semibold text-lg">on-chain</Base>
          </div>
        </div>
      )}
    </div>
  );
};
